import React, { useState, useEffect, useContext } from 'react'

import { withStyles } from '@material-ui/core/styles'
import { default as MUITabs } from '@material-ui/core/Tabs'
import { default as MUITab } from '@material-ui/core/Tab'

const StyledMUITab = withStyles((theme) => ({
  root: {
    textTransform: 'none',
    fontSize: theme.typography.body1.fontSize,
    color: '#666',
    fontWeight: 700,
  },
  selected: {
    fontWeight: 700,
    color: '#000'
  },
}))(MUITab)

export const Tab = ({...props}) => {
  return (
    <StyledMUITab
      wrapped
      {...props}
      >
    </StyledMUITab>
  )
}

export const Tabs = ({ children, ...props}) => {
  return (
    <MUITabs
      {...props}
      indicatorColor='primary'
      >
      { children }
    </MUITabs>
  )
}
